import { isEqual, isBefore } from 'date-fns';

const isEqualOrBefore = (date: number | Date, dateToCompare: number | Date) =>
  isEqual(date, dateToCompare) || isBefore(date, dateToCompare);

export default isEqualOrBefore;
